import React from 'react';
import Typo from '../typo';

const PlayerInfoStats = ({ title, data }) => {
  return (
    <>
      <div className='si-playerInfo__stats'>
        <Typo component='p' className='si-playerInfo__stats-lbl'>
          {title}
        </Typo>

        <Typo component='p' className='si-playerInfo__stats-nums'>
          {data}
        </Typo>
      </div>
    </>
  );
};

export default PlayerInfoStats;
